import { cn } from "@/lib/utils";
import React from "react";

type Props = {
  containerClassName?: string;
  bottomContent?: React.ReactNode;
};

const GondolaLoading: React.FC<Props> = ({
  containerClassName,
  bottomContent,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2",
        containerClassName
      )}
    >
      <div className="relative flex max-h-[110px] min-h-[110px] min-w-[110px] max-w-[110px] items-center justify-center rounded-full border border-primary/20 lg:max-h-[140px] lg:min-h-[140px] lg:min-w-[140px] lg:max-w-[140px]">
        <div className="absolute h-full w-full animate-spin-slow rounded-full border-8 border-transparent border-b-muted-foreground/40"></div>
        <div className="z-10 flex items-center justify-center rounded-full bg-gradient-to-r from-muted p-3">
          <img
            className="h-[62.10px] w-[62.10px]"
            src="/assets/logos/gondola.svg"
            alt=""
          />
        </div>
      </div>
      <div className="flex items-center justify-center text-primary">
        {bottomContent}
      </div>
    </div>
  );
};

export default GondolaLoading;
